module.exports = __webpack_public_path__ + "img/baja-norte-logo.7f11af8e.png";